// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__360mb","header":"MessagesList_header__29ClA","chat":"MessagesList_chat__3zXLs"};